// Periodo indicativo di un preventivo senza data precisa: anno + mese o stagione facoltativi.
export interface DateHint {
  year: number;
  period?: string;
}

export const PERIOD_OPTIONS = [
  'jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec',
  'spring', 'summer', 'autumn', 'winter',
];

/** Anni proposti dal menu; `keep` resta in lista anche se passato (periodo già salvato). */
export function periodYears(count = 6, keep?: number | null): number[] {
  const first = new Date().getFullYear();
  const years = Array.from({ length: count }, (_, i) => first + i);
  const saved = Math.round(+(keep ?? 0));
  return saved && !years.includes(saved) ? [saved, ...years].sort((a, b) => a - b) : years;
}

export function periodLabel(hint: DateHint | null | undefined, t: (key: string) => string): string {
  const year = Math.round(+(hint?.year ?? 0));
  if (!year) return '';
  const p = hint?.period ?? '';
  return p && PERIOD_OPTIONS.includes(p) ? `${t('crea.period.' + p)} ${year}` : String(year);
}

/** Pulisce l'indicazione prima di salvarla: serve solo se manca la data precisa. */
export function cleanDateHint(date: string | null | undefined, hint: any): DateHint | null {
  const year = Math.round(+(hint?.year ?? 0));
  if (date || !year) return null;
  return { year, period: PERIOD_OPTIONS.includes(hint?.period) ? hint.period : '' };
}
